export default {
    AddAThirdPartyAfterSalesOrder: {
        Basic: 'Account Information of third-party after-sales order',
        Third: 'Customer Order No.',
        button: 'Please click the button on the right to select',
        Associate: 'Associate third-party order',
        channel: 'Select channel',
        store: 'Select store',
        type: 'After-sales type',
        stage: 'After-sales stage',
        Application: 'After-sales application time',
        After: 'After-sales reason',
        sales: 'Third-party after-sales Order No.',
        party: 'Third-party exchange Order No.',
        remarks: 'After-sales remarks',
        information: "Buyer's after-sales information",
        nickname: "Buyer's nickname",
        Return: 'Return logistics company',
        select: 'Please select logistics company',
        document: 'After-sales logistics number',
        Original: 'Original receiving address',
        Exchange: 'Exchange receiving person',
        phone: 'Exchange receiving phone number',
        address: 'Exchange receiving address',
        Detailed: 'Detailed address',
        product: 'After-sales product information',
        products: 'Add after-sales product',
        item: 'Exchange product information',
        Add: 'Add exchange product',
        associated: 'Select associated third-party order',
        Selectproducts: 'Select after-sales product',
        Related: 'Related third-party order:',
        SelectItem: 'Select exchange product',
        number: 'Please select associated Customer Order No.',
        antype: 'Please select after-sales type',
        thereason: 'Please select after-sales reason',
        thenumber: 'Please enter third-party after-sales Order No.',
        thestage: 'Please select after-sales stage',
        anorder: 'Please select related third-party sales order first',
        addproducts: 'Please add after-sales product first',
        msgWarning: 'The refund amount cannot be greater than the transaction amount！',
        anfirst: 'Please select related third-party order first',
        Are: 'Confirm deletion',
        deleted: 'Deletion successful',
        category: 'Refund category',
        amount: 'Refund amount',
        Refundtype: 'Refund type',
        message: "Buyer's comment",
        Sellermessage: "Seller's message",
        Refundmethod: 'Refund method',
        RefundID: 'Refund ID',
        Customer: 'Bank customer name',
        BSB: 'Bank-State-Branch',
        Bank: 'Bank account number',
        refundMsgTitle: 'Refund information',
        evidence: 'Evidence',
        form: {
            Original: 'Original sub-Order No.',
            Whether: 'Whether it is a gift',
            productID: 'Platform product ID',
            productcode: 'Platform product code',
            PlatformID: 'Platform specification ID',
            Platformcode: 'Platform specification code',
            Platformname: 'Platform product name',
            Product: 'Product quantity',
            commodity: 'System product code',
            SKU: 'System SKU code',
            Unit: 'Product unit price',
            Transaction: 'Transaction amount',
            Refund: 'Refund amount',
            Remarks: 'Remarks',

            classification: 'Product category',
            Productname: 'Product name',
            System: 'System product code',
            SKUCode: 'System SKU code',
            quantity: 'Product quantity',
            Retail: 'Product retail price',
        }
    }
};
